import { Col, Nav, Row, Stack } from 'react-bootstrap';
import { NavLink, Outlet, useParams, useLocation } from 'react-router-dom';

import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { el } from 'date-fns/locale';
import {
  getSignleStoredData,
  getStoredDataUsingKey,
  setSingleStoredData
} from '../../../../../helpers/localStorageHelper';
import { useSelector } from 'react-redux';
import { loggedUser } from '../../../../store/features/authSlice';
const PunchInOutNavigation = (props) => {
  const storageKey = getSignleStoredData('tab');
  useEffect(() => {
    setSingleStoredData('tab', 'team');
  }, []);
  const [selectedFilterTab, setSelectedFilterTab] = useState(() => {
    const storedValue = getSignleStoredData('selectFilterData');
    if (storedValue === null || storedValue === undefined || storedValue === 'not found') {
      return 'today';
    }
    return storedValue;
  });
  const [currentPage, setCurrentPage] = useState(
    getStoredDataUsingKey(storageKey, 'currentPage', 1)
  );

  const checkLoggedInUser = useSelector(loggedUser);
  let { projectId } = useParams();
  const location = useLocation();
  const { t, employeeCanViewTeam, setUpdateSelectedTab } = props;
  const currentURL = location.pathname;
  const navigateArray = [
    {
      label: t('page.punch_in_out_own_tab'),
      link: `/punch-in-out/own`,
      identity: `/own`
    }
  ];
  if (employeeCanViewTeam > 1) {
    navigateArray.push({
      label: t('page.punch_in_out_team_tab'),
      link: `/punch-in-out/team`,
      identity: '/team'
    });
  }
  // Filter tabs option
  const filterTabs = [
    { value: 'today', label: `${t('page.punch_in_out_filter_tabs_today')}` },
    { value: 'yesterday', label: `${t('page.punch_in_out_filter_tabs_yesterday')}` },
    { value: 'this_week', label: `${t('page.punch_in_out_filter_tabs_this_week')}` },
    { value: 'prev_week', label: `${t('page.punch_in_out_filter_tabs_prev_week')}` },
    { value: 'this_month', label: `${t('page.punch_in_out_filter_tabs_this_month')}` },
    { value: 'prev_month', label: `${t('page.punch_in_out_filter_tabs_prev_month')}` },
    { value: 'all', label: `${t('page.punch_in_out_filter_tabs_all')}` }
  ];

  // Filter Initialization
  useEffect(() => {
    if (currentURL.includes('team')) {
      let teamPunchInOut = {
        currentPage: currentPage,
        selectedFilterTab: selectedFilterTab
      };
      localStorage.teamPunchInOut = JSON.stringify(teamPunchInOut);
      localStorage.userSelectedPunchInOutTab = 'team';
    } else {
      let ownPunchInOut = {
        currentPage: currentPage,
        selectedFilterTab: selectedFilterTab
      };
      const storageKey = `user_${checkLoggedInUser.user.user_id}_hrms_${selectedFilterTab}_tab_data`;
      localStorage[storageKey] = JSON.stringify(ownPunchInOut);
      localStorage.userSelectedPunchInOutTab = 'own';
    }
    setSingleStoredData('selectFilterData', selectedFilterTab);
  }, [currentPage, selectedFilterTab]);

  return (
    <>
      <Stack className="punch-in-out-nav-wrapper d-flex flex-wrap row-gap-4 flex-md-row justify-content-between align-items-md-center">
        <div className="d-flex flex-column flex-sm-row row-gap-4 align-items-sm-center">
          <div className="page-title">
            <h1 className="title">{t('page.punch_in_out_list_label')}</h1>
          </div>
          <Nav className="custom-tabs">
            {navigateArray.map((navigateObject, index) => (
              <Nav.Item key={index}>
                <NavLink
                  className={
                    currentURL.includes(navigateObject.identity)
                      ? 'active-tab nav-link'
                      : 'nav-link'
                  }
                  // className={({ isActive }) => (isActive ? 'active-tab nav-link' : 'nav-link')}
                  to={navigateObject.link}>
                  {navigateObject.label}
                </NavLink>
              </Nav.Item>
            ))}
          </Nav>
        </div>

        <div className="breadcrumb-tabs text-center">
          {filterTabs.map((filter, index) => (
            <>
              <span
                key={index}
                style={
                  filter.value === selectedFilterTab
                    ? { color: '#14804A', fontWeight: '600' }
                    : { cursor: 'pointer' }
                }
                onClick={() => {
                  setSelectedFilterTab(filter.value);
                  setSingleStoredData('selectFilterData', filter.value);
                  setUpdateSelectedTab(filter.value);
                  setCurrentPage(1);
                }}>
                {filter.label}
              </span>
              {index < filterTabs.length - 1 && ' | '}
            </>
          ))}
        </div>
      </Stack>
      <Outlet />
    </>
  );
};
PunchInOutNavigation.propTypes = {
  t: PropTypes.func
};
export { PunchInOutNavigation };
